import { Component, ViewChild, AfterViewInit, QueryList, ViewChildren, ChangeDetectorRef, OnInit, EventEmitter, Output, AfterViewChecked } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { CommonFunctionsService } from '../../../services/common-functions.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { CommonDataService } from '../../../services/common-data.service';
import { Subject, takeUntil } from 'rxjs';
import { Constants } from '../../../constants/constants';
import { ReviewDetails } from '../../../models/ReviewDetails';
import { MatDialog } from '@angular/material/dialog';
import { NotesExportDialogComponent } from '../../dialog/notes-export-dialog/notes-export-dialog.component';
import { ReviewService } from '../../../services/review.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ExportObjectAsFieldValuePDFOptions } from '../../../models/ExportObjectAsFieldValuePDFOptions';
import { ExportTablesToPDFOptions } from '../../../models/ExportTableToPDF';
import { EllipsisDirective } from '../../../Directives/handel-ellipsis.directive';
import { SubsAndMiscCosts } from '../../../models/SubsAndMiscCosts';
import { MultilingualCurrencyPipe } from '../../../pipes/multilingual-currency/multilingual-currency.pipe';


@Component({
  selector: 'app-sol-subcontractors',
  imports: [CommonModule, 
    MatSortModule, 
    MatTableModule, 
    MatPaginatorModule, 
    TranslatePipe, 
    EllipsisDirective, 
    MultilingualCurrencyPipe],
  templateUrl: './sol-subcontractors.component.html',
  styleUrl: './sol-subcontractors.component.scss'
})
export class SolSubcontractorsComponent implements AfterViewInit, OnInit, AfterViewChecked {
  includeNotesInPdf: boolean = true;
  @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> | null = null;

  @ViewChild(MatSort) sort!: MatSort;
  subDataList: SubsAndMiscCosts[] = [];
  dataSourceSubAndMiscWise: { [key: string]: MatTableDataSource<SubsAndMiscCosts> } = {};
  groupedReviewList: any[] = [];
  subsAndMiscCostsDetails: SubsAndMiscCosts[] = new Array<SubsAndMiscCosts>();
  checkDataExists: boolean = false;
  destroy$ = new Subject<void>();
  @Output() disablePdf = new EventEmitter<boolean>();

  columns: { field: string, header: string, isRightAlign: boolean, colWidth: string, isCurrency: boolean }[] = [
    { field: 'description', header: 'REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.DESCRIPTION', isRightAlign: false, colWidth: '200px', isCurrency: false },
    { field: 'subcontractorCost', header: 'REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.SUBCONTRACTOR_COST', isRightAlign: true, colWidth: 'auto', isCurrency: true },
    { field: 'miscellaneousCost', header: 'REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.MISCELLANEOUS_COST', isRightAlign: true, colWidth: 'auto', isCurrency: true },
    { field: 'notes', header: 'REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.NOTES', isRightAlign: false, colWidth: 'auto', isCurrency: false },
  ];
  headersSubAndMiscWise: { [key: string]: string } = {};
  displayedColumnsSubAndMiscWise: string[] = [
    'description',
    'subcontractorCost',
    'miscellaneousCost',
    'notes'
  ];
  wideColumnsSubAndMiscWise: string[] = [];
  rightAlignColumnsSubAndMiscWise: string[] = [];

  constructor(private commonFunctions: CommonFunctionsService, private cdr: ChangeDetectorRef, private commonDataService: CommonDataService, private dialog: MatDialog, private readonly reviewService: ReviewService, private translate: TranslateService, private currencyPipe: CurrencyPipe) {}

  ngOnInit() {
    this.initializeSubsAndMiscCostsDetails();
    this.commonDataService.triggerTabMethod$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.exportToPdf(this.reviewService.selectedReview, Constants.SOL_SUBS_AND_MISC);
      });
    this.sendDisablePdfEvent();
  }
  sendDisablePdfEvent() {
    this.disablePdf.emit(false);
  }

  ngAfterViewInit() {
    if (this.paginators) {
      this.paginators.forEach((paginator, index) => {
        if (this.groupedReviewList[index]) {
          this.dataSourceSubAndMiscWise[this.groupedReviewList[index][0].levelID].paginator = paginator;
        }
      });
    }
    this.cdr.detectChanges();
  }

  ngAfterViewChecked() {
     this.translateHeaders();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initializeSubsAndMiscCostsDetails() {
    const newCostReviewObject = this.reviewService.newCostReviewObject;
    const subsAndMiscCostsDetails = newCostReviewObject?.subsAndMiscCostsDetails;
    if (subsAndMiscCostsDetails) {
      this.subsAndMiscCostsDetails = subsAndMiscCostsDetails;
      this.checkDataExists = true;
      this.processSubsAndMiscCostsDetails();
    } else {
      this.resetSubsAndMiscCostsDetails();
    }
  }

  translateHeaders() {
    this.headersSubAndMiscWise = {
      levelID: this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.LEVEL_ID'),
      levelDescription: this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.LEVEL_DESCRIPTION'),
      description: this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.DESCRIPTION'),
      subcontractorCost: this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.SUBCONTRACTOR_COST'),
      miscellaneousCost: this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.MISCELLANEOUS_COST'),
      typicalOfCountInArea: this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.TYPICAL_OF_COUNT_IN_AREA'),
      isSystemLevel: this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.IS_SYSTEM_LEVEL'),
      notes: this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.NOTES'),
    };
    this.wideColumnsSubAndMiscWise = [
      this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.DESCRIPTION')
    ];
    this.rightAlignColumnsSubAndMiscWise = [
      this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.SUBCONTRACTOR_COST'),
      this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.MISCELLANEOUS_COST'),
      this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.TYPICAL_OF_COUNT_IN_AREA')
    ]
  }
  private processSubsAndMiscCostsDetails() {
    this.getAllMappedSubAndMiscWise();
    this.groupedReviewList = this.groupByLevelID(this.subDataList);
    this.addSumsToGroups();
  }

  private resetSubsAndMiscCostsDetails() {
    this.subsAndMiscCostsDetails = [];
    this.checkDataExists = false;
  }

  getAllMappedSubAndMiscWise() {
    this.subDataList = this.subsAndMiscCostsDetails.filter(
      detail => detail.subcontractorCost !== Constants.ZERO || detail.miscellaneousCost !== Constants.ZERO
    );
    if (this.subDataList.length > Constants.ZERO) {
      let isSystemLevel = false;
      this.subDataList.forEach(detail => {
        if (detail.isSystemLevel) {
          isSystemLevel = true;
        } else if (isSystemLevel) {
          detail.description = Constants.ADD_TAB + detail.description;
        }

        if (!this.dataSourceSubAndMiscWise[detail.levelID]) {
          this.dataSourceSubAndMiscWise[detail.levelID] = new MatTableDataSource<SubsAndMiscCosts>();
        }
        this.dataSourceSubAndMiscWise[detail.levelID].data.push(detail);
      });
    } else {
      this.checkDataExists = false;
    }

  }

appendCurrencySymbol(value: string | number): string | null {
    return this.currencyPipe.transform(value, this.translate.instant('COMMON_LABELS.CURRENCY'), 'symbol-narrow', '', this.translate.instant('COMMON_LABELS.LOCALE_CODE'));
  }


  groupByLevelID(list: SubsAndMiscCosts[]): any[] {
    const groups: { [key: string]: SubsAndMiscCosts[] } = {};
    list.forEach(item => {
      if (!groups[item.levelID]) {
        groups[item.levelID] = [];
      }
      groups[item.levelID].push(item);
    });
    return Object.values(groups);
  }

  addSumsToGroups() {
    const columnsToSum = ['subcontractorCost', 'miscellaneousCost'];
    this.groupedReviewList.forEach(group => {
      const sum: any = { description: this.translate.instant('REVIEW_SOL_RISK_TAB.TOTAL') };
      columnsToSum.forEach(column => {
        sum[column] = group.reduce((acc: number, item: any) => acc + (item[column] || 0), 0);
      });
      group.push(sum);
    });
  }

  exportToPdf(selectedReview: ReviewDetails, tabName: string) {
    if (tabName !== Constants.SOL_SUBS_AND_MISC) return;

    if (!this.subsAndMiscCostsDetails.length) {
      this.exportNoDataFound(selectedReview);
      return;
    }

    const dialogRef = this.dialog.open(NotesExportDialogComponent, {
      width: '350px',
      data: { notes: this.includeNotesInPdf },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result: boolean | undefined) => {
      if (result === undefined) return;
      this.includeNotesInPdf = result;

      const displayedColumns = this.getDisplayedColumns();
      const headers = this.getHeaders();

      const tables = this.buildTables(displayedColumns, headers);

      const options: ExportTablesToPDFOptions = {
              tables,
              fileName:  'subcontractors_and_miscellaneous_costs_report.pdf',
              hasNotes: this.includeNotesInPdf,
              estimateID: selectedReview.estimateID,
              estimateName: selectedReview.request,
              tabName:  this.translate.instant('REVIEW_SOL_TABS_LABELS.SUBS_MISC'),
            };
            this.commonFunctions.exportTablesToPDF(options);

      // this.commonFunctions.exportTablesToPDF(
      //   tables,
      //   'subcontractors_and_miscellaneous_costs_report.pdf',
      //   this.includeNotesInPdf,
      //   selectedReview.estimateID,
      //   selectedReview.request,
      //   this.translate.instant('REVIEW_SOL_TABS_LABELS.SUBS_MISC'),
      // );
    });
  }

  exportNoDataFound(selectedReview: ReviewDetails) {

    const options: ExportObjectAsFieldValuePDFOptions = {
      data: {
        [Constants.EMPTY_STRING]: this.translate.instant('REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.SUBCONTRACTOR_MISCELLANEOUS_DATA_NOT_FOUND')
      },
      title: Constants.EMPTY_STRING,
      fileName: 'subcontractors_and_miscellaneous_costs_report.pdf',
      estimateID: selectedReview.estimateID,
      estimateName: selectedReview.request,
      tabName: this.translate.instant('REVIEW_SOL_TABS_LABELS.SUBS_MISC'),
    };
    this.commonFunctions.exportObjectAsFieldValuePDF(options);
  }

  getDisplayedColumns(): string[] {
    return this.includeNotesInPdf
      ? this.displayedColumnsSubAndMiscWise
      : this.displayedColumnsSubAndMiscWise.filter(col => col.toLowerCase() !== 'notes');
  }

  getHeaders(): { [key: string]: string } {
    const headers = { ...this.headersSubAndMiscWise };
    if (!this.includeNotesInPdf) {
      delete headers['notes'];
    }
    return headers;
  }

  buildTables(displayedColumns: string[], headers: { [key: string]: string }) {
    return this.groupedReviewList.map((group, idx) => {
      const levelDescription = group[0]?.levelDescription || `Level ${group[0]?.levelID || idx + 1}`;
      const data = this.includeNotesInPdf
        ? group
        : group.map((item: SubsAndMiscCosts) => {
          const { notes, ...rest } = item;
          return rest;
        });

      return {
        title: `${levelDescription}`,
        displayedColumns: displayedColumns,
        headers: headers,
        data: data,
        typeGuard: (row: any, col: string) => row[col as keyof typeof row]
      };
    });
  }
}
